import React, { memo } from 'react';
import { ButtonSizeDLS, ButtonTypeTokens, FontFamilyTokens, } from '@voltmoney/schema';
import { ButtonBase } from './Button.base';
import ThemeProvider from '@voltmoney/theme';
import { ButtonBaseDLS } from "./ButtonDLS.base";
/**
 * Primary UI component for user interaction
 */
const Button = ({ id, fontFamily, type = ButtonTypeTokens.LargeFilled, onPress, height, customWidth, typeDLS, isDisabled, iconName, sizeDLS = ButtonSizeDLS.MEDIUM, paddingHorizontalDC, ...props }) => {
    /**
     *  logic -> base-component(...props
     * */
    const theme = ThemeProvider.getTheme();
    const buttonThemeProps = theme.button[type];
    if (typeDLS) {
        return (React.createElement(ButtonBaseDLS, { id: id, onPress: onPress, typeDLS: typeDLS, sizeDLS: sizeDLS, isDisabled: isDisabled, iconName: iconName, paddingHorizontalDC: paddingHorizontalDC, ...buttonThemeProps, ...props }));
    }
    return (React.createElement(ButtonBase, { id: id, fontFamily: fontFamily || FontFamilyTokens.Inter, isDisabled: type === ButtonTypeTokens.LargeOutline, onPress: onPress, height: height, customWidth: customWidth, ...buttonThemeProps, ...props }));
};
export default memo(Button);
export { Button };
